// @flow

import {CONTENT_TYPE_KEY, CONTENT_TYPE_JSON} from '../constants';

import type {Headers, RequestBodyData} from '../typedef';

type Input = { headers: Headers, params: RequestBodyData };

type Output = {
    headers: Headers,
    body: string,
};

type PrepareBodyData = (data: Input) => Output;

export const prepareBodyData: PrepareBodyData = ({headers, params}) => ({
    headers: {
        ...headers,
        [CONTENT_TYPE_KEY]: headers[CONTENT_TYPE_KEY] || CONTENT_TYPE_JSON
    },
    body: typeof params === 'string' ? params : JSON.stringify(params)
});

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
